import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <main className="mx-auto max-w-2xl px-6 py-24 text-center">
      <p className="mb-2 text-sm uppercase tracking-wider text-[var(--color-schist)]">404</p>
      <h1 className="mb-4 text-3xl font-semibold text-[var(--color-basalt)]">Page not found</h1>
      <p className="mb-8 text-[var(--color-slate)]">
        The path you're looking for doesn't exist. It may have moved, or never existed.
      </p>
      <Link
        to="/"
        className="text-sm text-[var(--color-terracotta)] underline-offset-4 hover:underline"
      >
        ← Back to home
      </Link>
    </main>
  )
}
